import React from "react";
import PhoneInput from "react-phone-number-input";
import { patienttitles } from "../../../../../utils/title";
import PersonIcon from "@mui/icons-material/Person";
import WcIcon from "@mui/icons-material/Wc";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function NewPatientAppointment({ formData, setformData }: any) {
  const handlePhonenumber = (e: any) => {
    setformData({ ...formData, mobileNo: e });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setformData((prevFormData: any) => ({ ...prevFormData, [name]: value }));
  };

  return (
    <div className="space-y-4">
      {/* Full Name */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <PersonIcon sx={{ fontSize: 18 }} className="text-indigo-500" />
          Full Name <span className="text-red-500">*</span>
        </label>
        <div className="flex gap-2">
          <select
            name="title"
            required={true}
            onChange={handleChange}
            value={formData.title}
            className="px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-700"
          >
            <option value="">Title</option>
            {patienttitles.map((item: any, i: number) => (
              <option key={i} value={item.value}>
                {item.title}
              </option>
            ))}
          </select>
          <input
            type="text"
            name="fullName"
            onChange={handleChange}
            value={formData.fullName}
            placeholder="Enter full name"
            className="flex-1 px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
          />
        </div>
      </div>

      {/* Gender */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <WcIcon sx={{ fontSize: 18 }} className="text-indigo-500" />
          Gender <span className="text-red-500">*</span>
        </label>
        <select
          name="gender"
          required={true}
          onChange={handleChange}
          value={formData.gender}
          className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-700"
        >
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
      </div>

      {/* Mobile No */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <PhoneIcon sx={{ fontSize: 18 }} className="text-indigo-500" />
          Mobile Number
        </label>
        <div className="[&_.PhoneInput]:bg-slate-50 [&_.PhoneInput]:border [&_.PhoneInput]:border-slate-200 [&_.PhoneInput]:rounded-xl [&_.PhoneInput]:px-4 [&_.PhoneInput]:py-2 [&_.PhoneInputInput]:bg-transparent [&_.PhoneInputInput]:outline-none [&_.PhoneInputInput]:border-none">
          <PhoneInput
            international
            countryCallingCodeEditable={false}
            defaultCountry="LK"
            value={formData.mobileNo}
            onChange={handlePhonenumber}
          />
        </div>
      </div>

      {/* Date of Birth */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <CalendarTodayIcon sx={{ fontSize: 18 }} className="text-indigo-500" />
          Date of Birth
        </label>
        <input
          type="date"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
          className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
        />
      </div>

      {/* Address */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <LocationOnIcon sx={{ fontSize: 18 }} className="text-indigo-500" />
          Address
        </label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          placeholder="Enter address"
          className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
        />
      </div>
    </div>
  );
}

export default NewPatientAppointment;
